import { ShopByVehicle } from "../../components/homepageSearchWidget/cosmos/shopByVehicle/shopByVehicle";
import { importClassOnScroll } from "../../utilities/dynamicImportsUtility";

class HomePageSearchWidgetCosmos {
  public constructor() {
    new ShopByVehicle();
    this.loadWidgetOnScroll();
  }

  private loadWidgetOnScroll() {
    const widgetElement = document.querySelector("#homepageSearchWidgetCosmos");

    if (widgetElement) {
      importClassOnScroll(
        () =>
          import(
            /* webpackChunkName: "homepageSearchWidgetCosmos" */ `../../components/homepageSearchWidget/cosmos/homepageSearchWidgetCosmos`
          ),
        widgetElement,
        true
      );
    }
  }
}

new HomePageSearchWidgetCosmos();
